import { CalendarPlatform } from '../calendar.enum';

export interface CalendarRsvpStepConfig {
  platform?: CalendarPlatform;
  responseStatus: string;
  eventId?: string;
  calendarEmailAddress?: string;
}

export interface CalendarCreateEventStepConfig {
  platform?: CalendarPlatform;
  summary: string;
  description?: string;
  startDateTime: string;
  endDateTime: string;
  timeZone?: string;
  location?: string;
  attendees?: string[];
  calendarEmailAddress?: string;
  /**
   * When true, attaches a video conference to the event (Google Meet on Gmail,
   * Teams on Outlook) so the create result exposes a joinable meeting link.
   */
  addConferencing?: boolean;
}

export interface CalendarDeleteEventStepConfig {
  platform?: CalendarPlatform;
  eventId?: string;
  sendCancellation?: boolean;
  calendarEmailAddress?: string;
}

export interface CalendarRescheduleEventStepConfig {
  platform?: CalendarPlatform;
  eventId?: string;
  startDateTime: string;
  endDateTime: string;
  timeZone?: string;
  calendarEmailAddress?: string;
}

export interface CalendarAddAttendeesStepConfig {
  platform?: CalendarPlatform;
  eventId?: string;
  attendees: string[];
  calendarEmailAddress?: string;
}

export interface CalendarRemoveAttendeesStepConfig {
  platform?: CalendarPlatform;
  eventId?: string;
  attendees: string[];
  calendarEmailAddress?: string;
}

export interface LoadMeetingsStepConfig {
  platform?: CalendarPlatform;
  calendarId?: string;
  timeInterval?: string;
  hours?: string;
  calendarEmailAddress?: string;
  startDateTime?: string;
  endDateTime?: string;
}

export interface CalendarInfo {
  calendarId: string;
  name: string;
  platform: CalendarPlatform;
  accountEmail: string;
  isPrimary: boolean;
  color?: string;
  canEdit?: boolean;
}

export interface CalendarEventAttendeeInfo {
  email?: string;
  displayName?: string;
  responseStatus?: string;
  organizer?: boolean;
}

export interface CalendarEvent {
  id: string;
  calendarId: string;
  accountEmail: string;
  platform: CalendarPlatform;
  title?: string;
  description?: string;
  location?: string;
  start: string;
  end: string;
  allDay: boolean;
  status?: string;
  htmlLink?: string;
  meetingUrl?: string;
  isOrganizer?: boolean;
  recurringEventId?: string;
  recurrence?: CalendarEventRecurrence;
  attendees?: CalendarEventAttendeeInfo[];
}

export enum RecurrenceFrequency {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY',
}

export enum RecurrenceWeekday {
  MO = 'MO',
  TU = 'TU',
  WE = 'WE',
  TH = 'TH',
  FR = 'FR',
  SA = 'SA',
  SU = 'SU',
}

export interface CalendarEventRecurrence {
  frequency: RecurrenceFrequency;
  interval?: number;
  byWeekday?: RecurrenceWeekday[];
  count?: number;
  until?: string;
}

export interface CalendarEventInput {
  accountEmail: string;
  platform: CalendarPlatform;
  calendarId: string;
  title?: string;
  description?: string;
  location?: string;
  start: string;
  end: string;
  allDay: boolean;
  timeZone?: string;
  addConference?: boolean;
  attendees?: string[];
  recurrence?: CalendarEventRecurrence;
}
